"use client"

import { Typography } from "@mui/material"
import { extractProperty } from "utils"

type Props = {
  data: any
}

const MainTitle = ({ data }: Props) => {
  const title = extractProperty(data, "title")
  return (
    <Typography variant="h2" component={"h1"}>
      {title}
    </Typography>
  )
}

export default MainTitle
